import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
interface ButtonCTAProps {
  text?: string;
  className?: string;
  href?: string;
  external?: boolean;
}
export function ButtonCTA({
  text = 'QUIERO SABORES QUE ADELGAZAN AHORA',
  className = '',
  href = '#comprar',
  external = false
}: ButtonCTAProps) {
  const handleClick = () => {
    if (external) {
      trackAddToCart();
    }
  };
  return <a href={href} onClick={handleClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-block bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-4 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:-translate-y-1 text-center w-full sm:w-auto ${className}`} data-id="element-13">
      {text}
    </a>;
}